import { render } from "./InvoiceEmptyList.vue?vue&type=template&id=005d247a&scoped=true"
import script from "./InvoiceEmptyList.vue?vue&type=script&lang=js"
export * from "./InvoiceEmptyList.vue?vue&type=script&lang=js"

import "./InvoiceEmptyList.vue?vue&type=style&index=0&id=005d247a&lang=scss&scoped=true"

import exportComponent from "H:\\_LK\\workInProgress\\invoice-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-005d247a"]])

export default __exports__